import {GetAllModelationsParams} from '@cmp/shared/models/api.model';
import {ModelationList} from '@generated/models';

export interface ModelationsState {
  modelations?: ModelationList[];
  params: GetAllModelationsParams;
  totalCount?: number;
}

export const initialModelationsState: ModelationsState = {
  params: {},
};
